import { useState, useEffect } from 'react';
import CloseIcon from '../../../assets/icons/close.svg?react';
import { useCreateCharger } from '../../../hooks/queries/chargerQueries';

const ChargerAppendSideModal = ({onClose, onSuccess, onStationSearch, selectedStation, setSelectedStation}) => {
  const [chargerAppendObject, setChargerAppendObject] = useState({
    cpoStationId: null,
    cpoChargerId: null,
    chargerCapacity: null,
    extensionDataSysId: null,
    stationSysId: null
  });
  
  const createChargerMutation = useCreateCharger();

  useEffect(() => {
    if(selectedStation){
      setChargerAppendObject({ ...chargerAppendObject,cpoStationId: selectedStation.CpoStationId, stationSysId: selectedStation.StationSysId });
    }
  }, [selectedStation]);

  useEffect(() => {
    setSelectedStation(null);
  }, []);

  const handleChargerAppendObject = (e) => {
    setChargerAppendObject({ ...chargerAppendObject, [e.target.id]: e.target.value });
  };
  
  const handleChargerAppend = async () => {
    if(!chargerAppendObject.cpoChargerId || !chargerAppendObject.chargerCapacity || !chargerAppendObject.stationSysId){
      return;
    }
    
    try {
      await createChargerMutation.mutateAsync(chargerAppendObject);
      onSuccess();
      onClose();
    } catch (error) {
      alert('충전기 추가에 실패했습니다.');
    }
  };
  return (
    <div className="side-modal-background">
      <div className="side-modal-container">
        <div className="side-modal-header">
          <h3>충전기 추가</h3>
          <div className="side-modal-close" onClick={onClose}>
            <CloseIcon />
          </div>
        </div>
        <div className="side-modal-content">
          <table className='transparent-table w-full'>
            <tr>  
              <td>
                <label htmlFor="cpoChargerId" className='w-20 mr-10 text-b2-700 required'>충전기 고유식별자</label>
              </td>
              <td>
                <input value={chargerAppendObject.cpoChargerId} type="text" id="cpoChargerId" className='w-full input-primary' placeholder='충전기 고유식별자를 입력해주세요.' onChange={handleChargerAppendObject}/>
              </td>
            </tr>
            {/* <p className='text-c2-400 text-gray-600'>충전기 고유식별자를 입력하세요</p> */}
            <tr>
              <td>
                  <label htmlFor="chargerCapacity" className='w-20 mr-10 text-b2-700 required'>용량(kWh)</label>
              </td>
              <td>
                  <input value={chargerAppendObject.chargerCapacity} type="text" id="chargerCapacity" className='w-full input-primary' placeholder='용량을 입력해주세요.' onChange={handleChargerAppendObject}/>
              </td>
            </tr>
            <tr>
              <td>
                  <label htmlFor="cpoStationId" className='w-20 mr-10 text-b2-700 required'>충전소 식별자</label>
              </td>
              <td>
                <input value={chargerAppendObject.cpoStationId} type="text" id="cpoStationId" className='w-full input-primary' placeholder='충전소 검색을 통해 선택해주세요.' readOnly/>
              </td>
            </tr>
          </table>
          <div className='flex justify-end mb-10'>
            <button className='btn big-btn btn-style-2' onClick={onStationSearch}>충전소 검색</button>
          </div>
          <div className='flex justify-end'>
            <button 
              className='btn big-btn btn-primary w-full' 
              onClick={handleChargerAppend}
              disabled={createChargerMutation.isPending}
            >
              {(createChargerMutation.isPending) ? '등록 중...' : '등록하기'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChargerAppendSideModal